__turbopack_context__.v({
  "activeStep": "roi-calculator-module__mM5BUa__activeStep",
  "back": "roi-calculator-module__mM5BUa__back",
  "inactiveStep": "roi-calculator-module__mM5BUa__inactiveStep",
  "next": "roi-calculator-module__mM5BUa__next",
  "step": "roi-calculator-module__mM5BUa__step",
});
